import { render, staticRenderFns } from "./CopyNotification.vue?vue&type=template&id=8ef49314&"
import script from "./CopyNotification.vue?vue&type=script&lang=js&"
export * from "./CopyNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports